import { makeRequest } from '../../../lib/api';
import {
  GetPostRequest, GetServicePostRequest, DeleteAndRestoreServicePosInterface,
  CreatePostOfficeWeekInterface, UpdatePostOfficeWeekInterface,
} from '../api/schedulerReferenceApi';

import {
  GeneratePostOfficeHalfYear, UpdatePostOfficeHalfYearInterface,
  CreatePostOfficeHalfYearInterface,
} from '../api/schedulerHalfYear';

import {
  SchedulerRequestInterface, SchedulerPutRequestInterface,
  SchedulerPostRequestInterface, MoveAppointmentRequest,
  AvailableDatesRequestInterface, AvailableTimesRequestInterface,
  AvailableDatesByOfficeRequestInterface, AvailableTimesByOfficeRequestInterface,
  DeletedAppointmentRequestInterface, FoundAppointmentRequestInterface,
  TimelineRequestInterface,
  SchedulerStretchRequestInterface,
  AppointmentExecutorsRequest,
  FifthWheelAppointmentsRequestInterface,
} from '../api/schedulerApi';
// import { PricesCalculateStationTireFittingRequest } from '../api/priceCalculateApi';
import forOwn from 'lodash/forOwn';
import {
  SetStatusNoticeRequest,
} from '../api/schedulerStatusNoticeApi';

const OFFICE_POST_PATH = '/v1/office_post';
const SERVICE_POST_PATH = '/v1/service_post';
const TIMETABLE_PATH = '/v1/users/timetable'; // Недельное расписание
const ACTUAL_TIMETABLE_PATH = '/v1/users/actual_timetable'; // Полугодовое расписание
const SCHEDULER_PATH = '/v1/users/scheduler'; // планировщик (журнал записи)
const SCHEDULER_PATH_v2 = '/v2/users/scheduler'; // планировщик (журнал записи) - редакция 2 (Timeline)

// const ORDERS_PATH = '/v1/orders';

class schedulerController {
  getPostOffices = (data: GetPostRequest) => {
    const param = (data?.partnerId ? `&partnerId=${ data?.partnerId }` : '')
    + (data?.partnerOfficeId ? `&partnerOfficeId=${ data?.partnerOfficeId }` : '');
    return makeRequest('get', `${ OFFICE_POST_PATH }?showDeleted=${ data.showDeleted }${ param }`);
  };

  createPost = (data) => {
    return makeRequest('post', `${ OFFICE_POST_PATH }`, data);
  };

  updatePost = (data) => {
    return makeRequest('put', `${ OFFICE_POST_PATH }`, data);
  };

  deletePost = (data) => {
    return makeRequest('delete', `${ OFFICE_POST_PATH }`, data);
  };

  restorePost = (data) => {
    return makeRequest('post', `${ OFFICE_POST_PATH }/restore`, data);
  };

  getServicePosts = (data: GetServicePostRequest) => {
    return makeRequest('get', `${ SERVICE_POST_PATH }?officePostId=${ data.officePostId }`);
  };

  createServicePost = (data) => {
    return makeRequest('post', `${ SERVICE_POST_PATH }`, data);
  };

  /*  updateServicePost = (data) => {
    return makeRequest('put', `${ SERVICE_POST_PATH }`, data);
  }; */

  deleteServicePost = (data: DeleteAndRestoreServicePosInterface) => {
    return makeRequest('delete', `${ SERVICE_POST_PATH }/${ data.id }`);
  };

  restoreServicePost = (data: DeleteAndRestoreServicePosInterface) => {
    return makeRequest('put', `${ SERVICE_POST_PATH }/${ data.id }`);
  };

  /* Блок для недельного расписания */
  getPostOfficeWeek = (postOfficeId: string) => {
    return makeRequest('get', `${ TIMETABLE_PATH }/${ postOfficeId }`);
  };

  createPostOfficeWeek = (data: CreatePostOfficeWeekInterface) => {
    return makeRequest('post', `${ TIMETABLE_PATH }`, data);
  };

  updatePostOfficeWeek = (id: string, data: UpdatePostOfficeWeekInterface) => {
    return makeRequest('put', `${ TIMETABLE_PATH }/${ id }`, data);
  };

  deletePostOfficeWeek = (id: string) => {
    return makeRequest('delete', `${ TIMETABLE_PATH }/${ id }`);
  };
  /* Конец блока для недельного расписания */

  /* Блок для полугодового расписания */
  getPostOfficeHalfYear = (postOfficeId: string) => {
    return makeRequest('get', `${ ACTUAL_TIMETABLE_PATH }/${ postOfficeId }`);
  };

  generatePostOfficeHalfYear = (data: GeneratePostOfficeHalfYear) => { // автоматическое заполнение расписание сразу на полгода
    return makeRequest('post', `${ ACTUAL_TIMETABLE_PATH }/generate`, data);
  };

  deletePostOfficeHalfYear = (id: string) => {
    return makeRequest('delete', `${ ACTUAL_TIMETABLE_PATH }/${ id }`);
  };

  createPostOfficeHalfYear = (data: CreatePostOfficeHalfYearInterface) => {
    return makeRequest('post', `${ ACTUAL_TIMETABLE_PATH }`, data);
  };

  updatePostOfficeHalfYear = (id: string, data: UpdatePostOfficeHalfYearInterface) => {
    return makeRequest('put', `${ ACTUAL_TIMETABLE_PATH }/${ id }`, data);
  };

  /* Конец блока для полугодового расписания */

  /* Блок для расписания (планировщик) */
  getSchedulerByDate = (request: SchedulerRequestInterface) => {
    return makeRequest('post', `${ SCHEDULER_PATH }/find`, request);
  };

  getOneAppointment = (appointmentJournalId: string) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/${ appointmentJournalId }`);
  };

  createAppointmentByDateTime = (data: SchedulerPostRequestInterface) => {
    return makeRequest('post', `${ SCHEDULER_PATH }`, data);
  };

  updateAppointmentById = (appointmentJournalId: string, data: SchedulerPutRequestInterface) => {
    return makeRequest('put', `${ SCHEDULER_PATH }/${ appointmentJournalId }`, data);
  };

  stretchAppointmentById = (appointmentJournalId: string, data: SchedulerStretchRequestInterface) => {
    return makeRequest('put', `${ SCHEDULER_PATH }/stretch/${ appointmentJournalId }`, data);
  };

  moveAppointmentById = (appointmentJournalId: string, data: MoveAppointmentRequest) => {
    return makeRequest('put', `${ SCHEDULER_PATH }/move/${ appointmentJournalId }`, data);
  };

  deleteAppointmentById = (appointmentJournalId: string) => {
    return makeRequest('delete', `${ SCHEDULER_PATH }/${ appointmentJournalId }`);
  };

  createOrderByAppointmentById = (appointmentJournalId: string, request: AppointmentExecutorsRequest) => {
    return makeRequest('post', `${ SCHEDULER_PATH }/order_by_appointment/${ appointmentJournalId }`,request);
  };

  getAvailableDates = (request: AvailableDatesRequestInterface) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/free_dates_by_appointment/${ request.appointmentJournalId }`);
  };

  getAvailableTimes = (request: AvailableTimesRequestInterface) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/time_slots_by_appointment?appointmentJournalId=${ request.appointmentJournalId }&date=${ request.date }`);
  };

  getAvailableDatesByOffice = (request: AvailableDatesByOfficeRequestInterface) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/free_dates?serviceId=${ request.serviceId }&partnerOfficeId=${ request.partnerOfficeId }`);
  };

  getAvailableTimesByOffice = (request: AvailableTimesByOfficeRequestInterface) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/time_slots?serviceId=${ request.serviceId }&partnerOfficeId=${ request.partnerOfficeId }&date=${ request.date }`);
  };

  /* Конец блока для расписания (планировщик) */

  getDeletedAppointments = (request: DeletedAppointmentRequestInterface) => {
    const param = `fromDate=${ request?.fromDate }&toDate=${ request?.toDate }${
      request?.partnerId ? `&partnerId=${ request?.partnerId }` : ''
    }${ request?.partnerOfficeId ? `&partnerOfficeId=${ request?.partnerOfficeId }` : '' }`;
    return makeRequest('get', `${ SCHEDULER_PATH }/appointment_journal_deleted?${ param }`, request);
  };

  getFoundAppointments = (request: FoundAppointmentRequestInterface) => {
    return makeRequest('post', `${ SCHEDULER_PATH }/search`, request);
  };

  // Журнал записей «5 колеса» (виджет офисов «5 колеса», отдельная таблица бэка)
  getFifthWheelAppointments = (request: FifthWheelAppointmentsRequestInterface) => {
    return makeRequest('post', `${ SCHEDULER_PATH }/fifth_wheel/appointments`, request);
  };

  // Отмена записи «5 колеса» (у нас и у партнёра; повторный вызов идемпотентен)
  cancelFifthWheelAppointment = (appointmentId: string) => {
    return makeRequest('post', `${ SCHEDULER_PATH }/fifth_wheel/appointments/${ appointmentId }/cancel`);
  };

  getAppointmentHistory = (appointmentJournalId: string) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/appointment_journal_history?id=${ appointmentJournalId }`);
  };

  getDeletedAppointmentHistory = (deletedAppointmentJournalId: string) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/appointment_journal_deleted_history?id=${ deletedAppointmentJournalId }`);
  };

  // блок для управления файлами в записи
  getFiles = (appointmentId: string) => {
    return makeRequest('get', `${ SCHEDULER_PATH }/${ appointmentId }/files`);
  };

  addAppointmentFile(data) {
    const { appointmentJournalId, ...rest } = data;
    const form = new FormData();
    forOwn(rest, (value, key) => {
      form.append(key, value);
    });
    return makeRequest('post', `${ SCHEDULER_PATH }/${ appointmentJournalId }/files`, form);
  }

  deleteAppointmentFile = (fileId: string) => {
    return makeRequest('delete', `${ SCHEDULER_PATH }/files/${ fileId }`);
  };
  // конец блок для управления файлами в записи

  /* Блок для Timeline */
  getTimeline = (request: TimelineRequestInterface) => {
    return makeRequest('post', `${ SCHEDULER_PATH_v2 }/find`, request);
  };

  // блок управления возвратами для Совкомбанка
  getSchedulerUndetermined = () => {
    return makeRequest('get', `${ SCHEDULER_PATH }/undetermined`);
  };

  updateStatusNotice = (request: SetStatusNoticeRequest) => {
    return makeRequest('put', `${ SCHEDULER_PATH }/b2b_status_notice/${ request.appointmentId }?status=${ request.status }`);
  }; 
}

export default new schedulerController();
